module.exports = __webpack_public_path__ + "img/virus-icon.54cb7294.png";